// Commercial — 4 KPIs cards (Taux visite, Dépôt ANAH, Octroi, CA AMO).
import { Target, FileCheck, Award, Euro, Loader2 } from "lucide-react";
import { useCommercialFetch } from "./useCommercialFetch";

function Kpi({ icon: Icon, label, value, sub, color }) {
  return (
    <div
      className="rounded-lg p-4"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
    >
      <div className="flex items-center gap-2 mb-2">
        <div
          className="w-8 h-8 rounded-md flex items-center justify-center"
          style={{ background: `${color}15`, color }}
        >
          <Icon className="w-5 h-5" />
        </div>
        <span className="text-xs font-medium" style={{ color: "var(--oh-text-muted)" }}>{label}</span>
      </div>
      <p className="text-xl font-bold" style={{ color: "var(--oh-text)" }}>{value}</p>
      <p className="text-xs mt-1" style={{ color: "var(--oh-text-muted)" }}>{sub}</p>
    </div>
  );
}

export default function CommercialKpisWidget() {
  const { data, loading, error } = useCommercialFetch();

  if (loading) {
    return (
      <div
        className="rounded-xl p-5 h-full flex items-center justify-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      >
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} />
      </div>
    );
  }
  if (error || !data) {
    return (
      <div
        className="rounded-xl p-5"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}
      >
        Erreur KPIs Commercial : {error || "données indisponibles"}
      </div>
    );
  }

  const { kpis = {}, funnel = [], total_dossiers = 0 } = data;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
      <Kpi icon={Target} label="Taux visite" color="var(--oh-stat-blue-text)"
        value={`${kpis.taux_visite || 0}%`}
        sub={`${funnel[1]?.count || 0} / ${total_dossiers}`} />
      <Kpi icon={FileCheck} label="Taux dépôt ANAH" color="#8B5CF6"
        value={`${kpis.taux_depot || 0}%`}
        sub={`${funnel[3]?.count || 0} déposés`} />
      <Kpi icon={Award} label="Taux octroi" color="#10B981"
        value={`${kpis.taux_octroi || 0}%`}
        sub={`${funnel[4]?.count || 0} octroyés`} />
      <Kpi icon={Euro} label="CA AMO total" color="var(--oh-stat-amber-text)"
        value={`${(kpis.total_ca_amo || 0).toLocaleString("fr-FR")} EUR`}
        sub={`${kpis.total_contrats || 0} contrats signés`} />
    </div>
  );
}
